// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-navbar {
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.custom-navbar img.brand {
  max-width: 220px !important;
  height: auto !important;
  width: auto;
  object-fit: contain;
  display: block;
}

#navbar {
  transition: 0.4s ease-in-out;
  background: #fff !important;
  z-index: 99;
}
#navbar nav.navbar {
  background-color: #fff;
  font-size: 1.4rem;
  font-family: "Poppins";
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.055);
}
#navbar nav.navbar img.brand {
  max-width: 260px;
  height: auto !important;
  width: auto;
  object-fit: contain;
  display: block;
  padding-left: 15px;
}
#navbar .nav-link {
  padding: 0 10px !important;
  font-size: 16px;
  font-weight: bold;
  transition: color 0.3s;
  font-family: "Poppins";
}
#navbar .nav-link:hover {
  color: #B80000;
}
#navbar .nav-link.primaryColor {
  color: #3FB9EA !important;
  font-family: "Poppins";
}
#navbar .nav-link.primaryColor:hover {
  color: #bd0000 !important;
}

.navLinksStyle {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.navLinksStyle .list {
  margin-bottom: 10px;
}
.navLinksStyle .list a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
  font-size: 16px;
  display: block;
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.navLinksStyle .list a:hover {
  background-color: #f2f2f2;
}

.sideMenuIcon {
  display: none;
  border: none;
  outline: none;
  background: transparent;
  color: #000;
}
.sideMenuIcon:hover {
  background: transparent;
  outline: none;
  border: none;
  color: #D60000;
}

::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  background: #fff;
}

::-webkit-scrollbar-thumb {
  background: #3FB9EA;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Defaults/Style.scss"],"names":[],"mappings":"AAOA;EACE,sBAAA;EACA,aAAA;EACA,wCAAA;AANF;AAQE;EACE,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AANJ;;AAWA;EACE,4BAAA;EACA,2BAAA;EACA,WAAA;AARF;AAUA;EACE,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;AARF;AAUE;EACI,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AARN;AAYE;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;AAVJ;AAYI;EACE,cAhDE;AAsCR;AAaI;EACE,yBAAA;EACA,sBAAA;AAXN;AAaM;EACE,yBAAA;AAXR;;AAkBA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,2DAAA;AAfN;AAiBM;EACE,yBAAA;AAfR;;AAuBA;EACE,aAAA;EAEA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AArBF;AAuBE;EACE,uBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AArBJ;;AA4BA;EACE,UAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,mBAxHQ;EAyHR,mBAAA;AAzBF","sourcesContent":["// Color Variables\r\n$primary: #3FB9EA;\r\n$secondary: #D60000;\r\n$hover: #B80000;\r\n$gray: #808080;\r\n\r\n\r\n.custom-navbar {\r\n  background-color: #fff;\r\n  padding: 10px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n\r\n  img.brand {\r\n    max-width: 220px !important;\r\n    height: auto !important;\r\n    width: auto;\r\n    object-fit: contain;\r\n    display: block;\r\n  }\r\n\r\n}\r\n\r\n#navbar {\r\n  transition: 0.4s ease-in-out;\r\n  background: #fff !important;\r\n  z-index: +99;\r\n\r\nnav.navbar {\r\n  background-color: #fff;\r\n  font-size: 1.4rem;\r\n  font-family: \"Poppins\";\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.055);\r\n\r\n  img.brand {\r\n      max-width: 260px;\r\n      height: auto !important;\r\n      width: auto;\r\n      object-fit: contain;\r\n      display: block;\r\n      padding-left: 15px;\r\n  }\r\n}\r\n\r\n  .nav-link {\r\n    padding: 0 10px !important;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    transition: color 0.3s;\r\n    font-family: 'Poppins';\r\n\r\n    &:hover {\r\n      color: $hover;\r\n    }\r\n\r\n    &.primaryColor {\r\n      color: $primary !important;\r\n      font-family: 'Poppins';\r\n\r\n      &:hover {\r\n        color: darken($secondary, 5%) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Top Side Nav\r\n.navLinksStyle {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  \r\n  .list {\r\n    margin-bottom: 10px;\r\n    \r\n    a {\r\n      text-decoration: none;\r\n      color: #333;\r\n      font-weight: bold;\r\n      font-size: 16px;\r\n      display: block;\r\n      padding: 10px;\r\n      border-radius: 5px;\r\n      transition: background-color 0.3s ease, transform 0.2s ease;\r\n    \r\n      &:hover {\r\n        background-color: #f2f2f2;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.sideMenuIcon {\r\n  display: none;\r\n  // visibility: hidden;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  color: #000;\r\n\r\n  &:hover {\r\n    background: transparent;\r\n    outline: none;\r\n    border: none;\r\n    color: #D60000;\r\n  }\r\n}\r\n\r\n\r\n// ?? Side Scroller\r\n// *** Scrolls ***\r\n::-webkit-scrollbar {\r\n  width: 7px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #fff;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: $primary;\r\n  border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
